import React from 'react';
import { InteractionManager, View } from 'react-native';

import { __WEB__, THEME } from '../../constants/styles';

import {
  NavBar,
  Navigation,
  NoCasesView,
  Container,
  Utils,
  NoAccess,
  OPComponent,
  I18n,
} from '../components';
import Calendar from './calendar';
import CalendarItem from './row_item/calendar_item';
import AddMenu from './add_menu';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentCase, getCurrentCaseEmployerType } from '../cases/selector';
import { getEventsForEmployer } from '../../selectors/entities';
import {
  canViewCalendar,
  canEditCalendar,
  shouldShowAllResidentsInCal,
  getEventsAndTaskListsFromCurrentCase,
  canSeeAllResidentsCalendar,
} from './selector';
import {
  LABS,
  PHA,
  DRHA,
  AUDIOGRAM,
  OHE,
  IMMUNIZATION_SCHEDULER,
  READINESS_CALENDAR,
  JUST_DO_IT,
} from '../../constants/permissions';
import { currentEmployerPermissions, currentCasePermissions } from '../../helpers/permissions';
import { doneSettingCurrentDate, fetchEventsForMonth } from './actions';

import {
  EVENT_TYPE_DRHA,
  EVENT_TYPE_LAB,
  EVENT_TYPE_AIRFORCE_DEPLOYMENT,
  EVENT_TYPE_IMMUNIZATION,
  EVENT_TYPE_AUDIOGRAM,
  EVENT_TYPE_PHA,
  EVENT_TYPE_OHE,
} from '../../constants/eventTypes';
import { CALENDAR_TAB } from '../../constants/tabs';

import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from '../../constants/employerTypes';
import { getAssociatedEmployer, getCurrentEmployer } from '../../selectors/employers';

import TopBarSetup from '../../navbar_maintab_setup';

import moment from 'moment';

class CalendarScreen extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: props.shouldScrollToDate || null,
      screenVisible: false,
      renderCalendar: false,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress(componentId, buttonId)) return;
  };

  handleDeepLink = ({ link, payload }) => {
    if (link === CALENDAR_TAB || link === 'calendar/main') {
      Navigation.switchToTab(CALENDAR_TAB, this.props.componentId);
    }
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this, null, 'Calendar');

    Utils.trackScreen('Calendar', 'Calendar');

    if (this.props.shouldScrollToDate) {
      this._resetScrollToDateInRedux();
    }

    // fetch events for the current month
    this._fetchEventsForMonth();
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  componentDidAppear(id) {
    console.info('>>> calendar componentDidAppear');
    Navigation.trackActiveTabNum(CALENDAR_TAB);
    this.setState({ screenVisible: true, renderCalendar: true });
  }

  componentDidDisappear(id) {
    console.info('>>>> calendar componentDidDisappear');
    this.setState({ screenVisible: false });
  }

  _resetScrollToDateInRedux() {
    InteractionManager.runAfterInteractions(() => {
      this.props.actions.doneSettingCurrentDate();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentEventId && this.props.currentEventId !== prevProps.currentEventId) {
      InteractionManager.runAfterInteractions(() => {
        this.openEventDetails({
          eventId: this.props.currentEventId,
          caseId: this.props.currentCaseId,
        });
      });
    }

    // if shouldScrollToDate gets set on props wait a render cycle and then call setSelectedDate
    // on the calendar
    if (this.props.shouldScrollToDate) {
      if (this.props.coldStartFinished && this.props.currentCaseId && this.state.renderCalendar) {
        this._scrollToDateOnUpdateDate = new Date(this.props.shouldScrollToDate);
      } else {
        // we haven't yet rendered the calendar so just set it up as the
        // selectedDate that's passed in on first render
        this.state.selectedDate = this.props.shouldScrollToDate;
      }
      this._resetScrollToDateInRedux();
    } else if (this._scrollToDateOnUpdateDate && this.state.screenVisible) {
      this._calendarRef?.setSelectedDate(this._scrollToDateOnUpdateDate);
      this._scrollToDateOnUpdateDate = null;
    }

    // fetch events on app startup or when a user has been added to an employer,
    // or if data has been cleared
    if (this.props.employer?.employerId !== prevProps.employer?.employerId) {
      this._monthDate = null;
      this._fetchEventsForMonth();
    }
    if (this.props.wsConnected && !prevProps.wsConnected) {
      this._monthDate = null;
      this._fetchEventsForMonth();
    }
    if (this.props.coldStartFinished && !prevProps.coldStartFinished) {
      this._monthDate = null;
      this._fetchEventsForMonth();
    }
    if (this.state.screenVisible && !prevState.screenVisible) {
      this._fetchEventsForMonth();
    }
  }

  _fetchEventsForMonth = (date) => {
    if (!this.props.wsConnected || !this.props.coldStartFinished) return;
    if (!date) date = this._selectedDate || new Date();
    const monthDate = moment(date).startOf('month').format('YYYY-MM-DD');
    if (this._monthDate !== monthDate) {
      this.props.actions.fetchEventsForMonth(monthDate);
    }
    this._monthDate = monthDate;
  };
  handleDateSelect = (date) => {
    this._selectedDate = date;
    this._fetchEventsForMonth(date);
  };

  handleNativeScrollDay = (date) => {
    this._fetchEventsForMonth(date);
  };

  handleMenuItemPress = () => {
    this.openNewEvent();
  };

  openNewEvent = (selectedDate) => {
    Utils.trackEvent('Navigation', 'Load', 'New Event');

    if (!this.props.canEdit) return;

    if (!selectedDate && this._selectedDate) {
      selectedDate = new Date(this._selectedDate);
    }

    if (selectedDate) {
      let dateForTime = new Date();
      selectedDate.setHours(dateForTime.getHours());
    }

    Navigation.openScreen(
      {
        screen: 'EventForm',
        title: I18n.ac('calendar.newEvent'),
        passProps: {
          onEventAdd: this.handleEventAdd,
          selectedDate,
        },
      },
      this.props.componentId,
      true
    );
  };

  handleEventAdd = (addedEvent) => {
    if (!addedEvent) return;
    Utils.trackEvent('Action', 'Tap', 'Create Event');
    this._scrollToDateOnUpdateDate = new Date(addedEvent.startDate);

    if (__WEB__) {
      requestAnimationFrame(() => {
        Navigation.dismissAllModals();
      });
    }
  };

  openEventDetails = ({ eventId, startDate, endDate, caseId, caseName }) => {
    Utils.trackEvent('Navigation', 'Load', 'Event Details');
    Navigation.openScreen(
      {
        screen: 'EventDetails',
        title: I18n.ac('calendar.eventDetails'),
        animationType: 'slide-up',
        passProps: {
          eventId,
          caseId,
          caseName,
          instanceStart: startDate,
          instanceEnd: endDate,
          editable: this.props.canEdit,
        },
      },
      this.props.componentId,
      true
    );
  };

  renderMenu = () => {
    if (!this.props.canEdit) return null;

    return (
      <AddMenu
        isAirforce={this.props.isAirforce}
        isMedRecuiter={this.props.isMedRecuiter}
        handleItemPress={this.handleMenuItemPress}
      />
    );
  };

  handleItemPress = (event) => {
    if (!event) return;
    const { eventId, startDate, endDate, caseId, caseName } = event;
    this.openEventDetails({ eventId, startDate, endDate, caseId, caseName });
  };

  _canEditDoItForEvent(item) {
    let canEdit = false;
    switch (item.eventTypeName) {
      case EVENT_TYPE_DRHA:
        canEdit = this.props.canEditDRHAEventsEmployer;
        break;
      case EVENT_TYPE_AUDIOGRAM:
        canEdit = this.props.canEditAudiogramEventsEmployer;
        break;
      case EVENT_TYPE_LAB:
        canEdit = this.props.canEditLabsEventsEmployer;
        break;
      case EVENT_TYPE_OHE:
        canEdit = this.props.canEditOHEEventsEmployer;
        break;
      case EVENT_TYPE_PHA:
        canEdit = this.props.canEditPHAEventsEmployer;
        break;
      case EVENT_TYPE_IMMUNIZATION:
        canEdit = this.props.canEditImmunizationEventsEmployer;
        break;
      case EVENT_TYPE_AIRFORCE_DEPLOYMENT:
        canEdit = this.props.canEditDeploymentEventsEmployer;
        break;
      default:
        canEdit = this.props.canEditJustDoItCurrentCase;
    }
    return canEdit;
  }

  renderItem = (item) => {
    if (this.props.showAllResidents) return this.renderItemOnOrgCalendar(item);

    const canEditJustDoIt = this._canEditDoItForEvent(item);
    return (
      <CalendarItem
        item={item}
        onPress={this.handleItemPress}
        sourceKey="CALENDAR"
        canEditJustDoIt={canEditJustDoIt}
        isMilitaryEmployer={this.props.isAirforce || this.props.isMedRecuiter}
      />
    );
  };
  renderItemOnOrgCalendar = (item) => {
    const canEditJustDoIt = this._canEditDoItForEvent(item);

    return (
      <CalendarItem
        item={item}
        displayType={'caseName'}
        onPress={this.handleItemPress}
        sourceKey="CALENDAR"
        canEditJustDoIt={canEditJustDoIt}
        isMilitaryEmployer={this.props.isAirforce || this.props.isMedRecuiter}
      />
    );
  };

  renderCalendar = () => {
    const {
      coldStartFinished,
      showAllResidents,
      currentCaseId,
      canView,
      canEdit,
      events,
      isAirforce,
      isMedRecuiter,
    } = this.props;

    if (!coldStartFinished || !this.state.renderCalendar) {
      return <Container style={THEME.containerAlt} />;
    } else if (!showAllResidents && !currentCaseId) {
      return (
        <Container style={THEME.containerAlt}>
          <NoCasesView />
        </Container>
      );
    } else if (!canView) {
      return <NoAccess />;
    }

    return (
      <Calendar
        ref={(ref) => (this._calendarRef = ref)}
        editable={canEdit}
        selectedDate={this.state.selectedDate}
        events={events}
        renderItem={this.renderItem}
        titleAccessor={showAllResidents ? 'caseName' : null}
        onEmptyDayTap={isAirforce || isMedRecuiter ? null : this.openNewEvent}
        onSelectedDate={this.handleDateSelect}
        renderMenu={this.renderMenu}
        onSelectEvent={this.openEventDetails}
        onNativeScrollDay={this.handleNativeScrollDay}
        isMilitaryEmployer={isAirforce || isMedRecuiter}
        isAirforceStaff={this.props.isAirforceStaff}
        showAllResidents={this.props.showAllResidents}
        canSeeAllResidentsOption={this.props.canSeeAllResidentsOption}
      />
    );
  };

  render() {
    return (
      <View style={{ flex: 1 }}>
        <TopBarSetup componentId={this.props.componentId} />
        {this.renderCalendar()}
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const showAllResidents = shouldShowAllResidentsInCal(state);
  const canSeeAllResidentsOption = canSeeAllResidentsCalendar(state);
  const events = showAllResidents
    ? getEventsForEmployer(state)
    : getEventsAndTaskListsFromCurrentCase(state);
  const associatedEmployer = getAssociatedEmployer(state);
  const currentEmployer = getCurrentEmployer(state);

  return {
    events,
    currentCaseId: state.application.currentCaseId,
    currentCaseObj: getCurrentCase(state),
    currentEventId: state.application.currentEventId,
    coldStartFinished: state.application.coldStartFinished,
    wsConnected: state.application.wsConnected,
    shouldScrollToDate: state.application.shouldScrollToDate,
    canView: canViewCalendar(state),
    canEdit: canEditCalendar(state),
    showAllResidents,
    canSeeAllResidentsOption,
    canEditImmunizationEventsEmployer: currentEmployerPermissions(IMMUNIZATION_SCHEDULER).canEdit,
    canEditDeploymentEventsEmployer: currentEmployerPermissions(READINESS_CALENDAR).canEdit,
    canEditDRHAEventsEmployer: currentEmployerPermissions(DRHA).canEdit,
    canEditLabsEventsEmployer: currentEmployerPermissions(LABS).canEdit,
    canEditOHEEventsEmployer: currentEmployerPermissions(OHE).canEdit,
    canEditAudiogramEventsEmployer: currentEmployerPermissions(AUDIOGRAM).canEdit,
    canEditJustDoItCurrentCase: currentCasePermissions(JUST_DO_IT).canEdit,
    currentCaseEmployerType: getCurrentCaseEmployerType(state),
    canEditPHAEventsEmployer: currentEmployerPermissions(PHA).canEdit,
    isAirforce: associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE,
    isMedRecuiter: associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER,
    isAirforceStaff: currentEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        doneSettingCurrentDate,
        fetchEventsForMonth,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarScreen);
